import api from "./api";
import API_URLS from "../../constants/api-urls";

export default class CaskMasterApi {
  createCaskMaster(payload) {
    return api.post(API_URLS.URL.caskmaster.createCaskMaster, payload);
  }

  updateCaskMaster(caskId, payload) {
    return api.put(
      API_URLS.URL.caskmaster.updateCaskMaster?.replace(":id", caskId),
      payload,
    );
  }

  getCaskMasterList(payload) {
    return api.post(API_URLS.URL.caskmaster.getCaskMasterList, payload);
  }
}
